import {useI18n} from '@logistics-frontend/core/i18n'
import React, {useMemo} from 'react'

import {DetailsProps} from '../../types'
import {DetailsList} from '../details-list'
import {getRequirements, hasMultiplier, mapSpecialRequirementsToListItems} from './utils'

type Props = Pick<DetailsProps, 'tariff'> & {
  isPostPaymentEnabled?: boolean
}

const SpecialRequirements: React.FC<Props> = ({tariff, isPostPaymentEnabled}) => {
  const t = useI18n()

  const items = useMemo(() => {
    const requirements = getRequirements(tariff).filter(hasMultiplier)
    const itemsWithMultipliers = mapSpecialRequirementsToListItems(requirements, t)

    const commissions = [
      {
        label: t('tariffs.property.card_payments_commission'),
        value: t('tariffs.property.card_payments_commission.value'),
      },
      {
        label: t('tariffs.property.pay_url_payments_commission'),
        value: t('tariffs.property.pay_url_payments_commission.value'),
      },
    ]

    return isPostPaymentEnabled ? itemsWithMultipliers.concat(commissions) : itemsWithMultipliers
  }, [isPostPaymentEnabled, tariff, t])

  return (
    <DetailsList
      items={items}
      title={t('tariffs.block_title.requirements_with_multiplier', 'Дополнительные услуги')}
      flexGrow
    />
  )
}

export default SpecialRequirements
